import { TimePeriod } from "./analyticsfilter.model";

export class ChartData {
  public Max: number;
  public Min: number;
  public StartDate: Date | null;
  public EndDate: Date | null;
}

export class BarPieChartData extends ChartData {
  public Total: number;
  public Unique: number;
}

export class DataPoint {
  public Total: number;
}

//TODO: normalize names to match the actual implementation names
export class AnalyticsTypeEnum {
  static readonly DownloadedManualsData = "DownloadedManualsData";
  static readonly ManualsOpenedData = "ManualsOpenedData";
  static readonly ManualsCurrentlyOpenData = "ManualsCurrentlyOpenData";
  static readonly UpdatedManualsData = "UpdatedManualsData";
  static readonly CreatedManualsData = "CreatedManualsData";
  static readonly DocumentsPrintedData = "DocumentsPrintedData";
  static readonly AnnotationsSentData = "AnnotationsSentData";
  static readonly SearchTermsUsedData = "SearchTermsUsedData";
  static readonly PagesOfManualsViewedData = "PagesOfManualsViewedData";
  static readonly ManualLanguagesData = "ManualLanguagesData";
  static readonly ApplicationLanguagesData = "ApplicationLanguagesData";
  static readonly ApplicationVersionsData = "ApplicationVersionsData";
  static readonly OsTypeData = "OsTypeData";
  static readonly OsVersionData = "OsVersionData";
  static readonly CreatedUsersData = "CreatedUsersData";
  static readonly CreatedUsersDataTotal = "CreatedUsersDataTotal";
  static readonly RemovedUsersData = "RemovedUsersData";
  static readonly RemovedUsersDataTotal = "RemovedUsersDataTotal";
  static readonly LockedUsersData = "LockedUsersData";
  static readonly LockedUsersDataTotal = "LockedUsersDataTotal";
  static readonly TotalUsersData = "TotalUsersData";
  static readonly UsersCurrentlyOnlineData = "UsersCurrentlyOnlineData";
  static readonly UserSessionsData = "UserSessionsData";
  static readonly AppUsageData = "AppUsageData";
  static readonly TotalCurrentUsersData = "TotalCurrentUsersData";
  static readonly GlobalSearchTermsData = "GlobalSearchTermsData";
  static readonly GlobalSearchTermDocumentsData =
        "GlobalSearchTermDocumentsData";
  static readonly CombinedSearchTermsData = "CombinedSearchTermsData";
}

export class AnalyticsDataResponse {
  AnalyticsType: string;
  TimePeriodType: TimePeriod | null;
  TimePeriodLength: number | null; // in minutes
  Data: any;
  DateCollected: Date;
}
